import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App'; // Use App for shared layout if needed
import ErrorBoundary from './components/ErrorBoundary';

// Dynamic imports for lazy loading pages
const Homepage = React.lazy(() => import('./pages/HomePage'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const ProjectsPage = React.lazy(() => import('./pages/ProjectsPage'));
const ContactPage = React.lazy(() => import('./pages/ContactPage'));

// Define routes
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <React.Suspense fallback={<div>Loading homepage...</div>}>
        <Homepage />
      </React.Suspense>
    ),
  },
  {
    path: "/about",
    element: (
      <React.Suspense fallback={<div>Loading about page...</div>}>
        <AboutPage />
      </React.Suspense>
    ),
  },
  {
    path: "/projects",
    element: (
      <React.Suspense fallback={<div>Loading projects page...</div>}>
        <ProjectsPage />
      </React.Suspense>
    ),
  },
  {
    path: "/contact",
    element: (
      <React.Suspense fallback={<div>Loading contact page...</div>}>
        <ContactPage />
      </React.Suspense>
    ),
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </React.StrictMode>
);
